/**
 * @module containers/Default
 * @author Charles Blais <charles.blais@canada.ca>
 */

import { Grid } from 'react-bootstrap';
import queryString from 'query-string';

import FormHazard from '../components/form/form-hazard';

import { useAppState } from '../contexts/app-state-provider';


/**
 * React container
 * ===============
 */
const Form = () => {
  const [ state ] = useAppState();

  return (
    <Grid>
      <FormHazard
        initialValues={state.form.initialValues}
        onSubmit={(values) => {
          switch(values.siteDesignation){
            case "XS":
              delete values.siteDesignationXV;
              break;
            case "XV":
              delete values.siteDesignationXS;
              break;
            default:
              break;
          }
          const url = `${window.location.pathname}?${queryString.stringify(values)}`;
          // @ts-ignore: ignore window error
          window.open(url, '_blank').focus();
        }}
      />
    </Grid>
  );
}

export default Form;
